// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/glide-range-estimation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/glide-range-estimation/glide-range-estimation.js';

mount([g0]);
